export default {
    whichEmbryosShouldBeKept                        :   "Which Embryos Should Be Kept",
    whichEmbryoDoYouWantToTransfer                  :   "Which Embryo Do You Want To Transfer",
    whatDoYouDoWithAnUnwantedFetus                  :   "What Do You Do With An Unwanted Fetus",
    description                                     :   "Description"
}